import { render, staticRenderFns } from "./FormularioAddVacunaMujer.vue?vue&type=template&id=7c71c90c&scoped=true"
import script from "./FormularioAddVacunaMujer.vue?vue&type=script&lang=js"
export * from "./FormularioAddVacunaMujer.vue?vue&type=script&lang=js"
import style0 from "./FormularioAddVacunaMujer.vue?vue&type=style&index=0&id=7c71c90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71c90c",
  null
  
)

export default component.exports